import {IComponentController} from "angular";
import "../../../styles/email-tone-row.scss";

export interface ToneOption {
    label: string;
    value: string;
}

export class EmailToneRow implements IComponentController {
    public toneOptions: Array<ToneOption>;
    public selectedTone: string;


    public static instance = {
        template: require('./email-tone-row.html'),
        controller: EmailToneRow,
        bindings: {
            toneOptions: '<',
            selectedTone: '='
        }
    };

    public getDescription(selectedTone: string): string {
        switch (selectedTone) {
            case "FRIENDLY":
                return "A friendly tone, suitable for casual conversations, making the communication approachable";
            case "PROFESSIONAL":
                return "A professional tone for formal and business communications.";
            case "ENTHUSIASTIC":
                return "An enthusiastic tone, conveying excitement and energy.";
            case "NEUTRAL":
                return "A neutral tone, balanced and unbiased, suitable for factual information.";
            case "PERSUASIVE":
                return "A persuasive tone, aiming to convince or influence the reader.";
            case "INFORMATIVE":
                return "An informative tone, focused on delivering facts and knowledge.";
            case "URGENT":
                return "An urgent tone, prompting immediate attention and action.";
            case "NON_URGENT":
                return "A non-urgent tone, indicating that no immediate action is required.";
            case "HIGH_PERSONALISATION":
                return "A highly personalized tone, tailored to the reader’s needs and preferences.";
            case "LOW_PERSONALISATION":
                return "A more general tone, with less focus on individual customization.";
            default:
                return "Select a tone to see the description.";
        }
    }

}
